import React from 'react';
import ShiftTypesSelect from './ShiftTypeSelect';
import { PlusCircle } from 'lucide-react';

export const ShiftTypesSection = ({ shiftTypes, onChange, onDeactivate, translations }) => {
  const canAddMore = shiftTypes.some(shift => !shift.active);
  const activeShifts = shiftTypes.filter(shift => shift.active);

  const handleAddShift = () => {
    const nextIndex = shiftTypes.findIndex(shift => !shift.active);
    if (nextIndex !== -1) {
      onChange(nextIndex, { active: true, type: '' });
    }
  };

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-md font-medium">{translations("form.schedule.shift")}</h3>
        {canAddMore && activeShifts.length > 0 && (
          <button
            onClick={handleAddShift}
            className="flex items-center gap-2 text-green-600 hover:text-green-700 transition-colors"
            title="Add Shift"
          >
            <PlusCircle size={20} />
            <span className="text-sm">{translations("form.schedule.addShift")}</span>
          </button>
        )}
      </div>

      <div className="space-y-3">
        {activeShifts.length === 0 ? (
          <button
            onClick={handleAddShift}
            className="w-full p-3 border-2 border-dashed border-gray-300 rounded-lg
                     text-gray-500 hover:border-green-500 hover:text-green-500
                     flex items-center justify-center gap-2 transition-colors"
          >
            <PlusCircle size={20} />
            <span>{translations("form.schedule.addShift")}</span>
          </button>
        ) : (
          activeShifts.map((shift, activeIndex) => {
            const originalIndex = shiftTypes.findIndex(s => s === shift);
            return (
              <div key={originalIndex} className="relative flex gap-2 items-start">
                <div className="flex-1">
                  <ShiftTypesSelect
                    label={`Shift ${activeIndex + 1}`}
                    value={shift.type}
                    onChange={(value) => onChange(originalIndex, { ...shift, type: value })}
                    onRemove={() => onDeactivate(originalIndex)}
                    translations={translations}
                  />
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};